// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import { Link } from "react-router-dom";
// import "jspdf-autotable";
// import { FULL_API_BASE_URL } from "../../../Config/Config";
// import Latex from "react-latex";
// import "katex/dist/katex.min.css";
// import he from "he";
// import StudentGroupDashboaardTable from "./StudentRegistrationTable";
// import EndPoints from "../../../Api/EndPoints";

// const StudentDashboard = ({
//   setMessageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
//   dataClient,
//   setPagePath,
// }) => {
//   const [reportDashboardData, setReportDashboardData] = useState([]);
//   const navigate = useNavigate();
//   const accessToken = localStorage.getItem("other");
//   const [headers, setHeaders] = useState([]);
//   const [selectedRows, setSelectedRows] = useState([]);

//   useEffect(() => {
//     if (dataClient) {
//       fetchDashboardData();
//     }
//   }, [dataClient]);

//   const userId = dataClient?.client_schema_name?.[6]?.[0]?.user_id;
//   const userName = dataClient?.client_schema_name?.[6]?.[0]?.user_name || null;
//   const clintBranchId = dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id;

//   const fetchDashboardData = async () => {
//     try {
//       const response = await fetch(
//         `${EndPoints.STUDENT_REG_DASHBOARD}?client_branch_id=${clintBranchId}`,
//         {
//           method: "GET",
//           headers: {
//             Authorization: `Bearer ${accessToken}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       if (!response.ok) {
//         throw new Error(
//           "Failed to fetch dashboard data. Please check the API or authentication details."
//         );
//       }

//       const result = await response.json();

//       let tableData, rawHeaders, rows;

//       if (result?.headers && result?.rows) {
//         rawHeaders = result.headers;
//         rows = result.rows;
//       } else if (result?.data) {
//         tableData = result.data;
//         rawHeaders = tableData[0] || [];
//         rows = tableData.slice(1) || [];
//       } else {
//         rawHeaders = [];
//         rows = [];
//       }

//       const formattedHeaders = rawHeaders.map((header) =>
//         String(header).replace(/^[a-zA-Z]\*/, "")
//       );

//       const transformedRows = rows.map((row) =>
//         row.map((cell) => {
//           if (cell === "" || cell === null || cell === undefined) {
//             return "---";
//           }
//           return cell;
//         })
//       );

//       setHeaders(formattedHeaders);
//       setReportDashboardData(transformedRows);
//     } catch (error) {
//       console.error("Error fetching dashboard data:", error);
//     }
//   };

//   const handleCancel = () => {
//     window.location.reload();
//   };

//   return (
//     <div
//       style={{
//         height: "auto",
//         width: "100%",
//         paddingLeft: "37px",
//         marginBottom: "40px",
//       }}
//     >
//       <div className="">
//         <div
//           style={{
//             backgroundColor: "white",
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             zIndex: 1001,
//             top: 0,
//           }}
//         >
//           <p style={{ color: "#2F2E40", fontSize: "30px" }}>
//             Student Registration Dashboard
//           </p>
//           <div style={{ display: "flex" }}>
//             <button
//               style={{
//                 padding: "12px",
//                 marginRight: "18px",
//                 boxShadow: "0px 4px 4px 0px #00000040",
//                 marginTop: "0",
//               }}
//               className="create-test-section-btn"
//               onClick={() => {
//                 navigate(`/student_registration`);
//               }}
//             >
//               NEW
//               <span style={{fontSize: "14px", fontWeight: "bold"}}>+</span>
//             </button>
//           </div>
//         </div>
//         <p style={{ marginTop: "10px", color: "#2F2E40" }}>
//           Student requests are listed here click on a student name to check status, edit or cancel the request or create a new request using New button.
//         </p>
//         <div>
//           <StudentGroupDashboaardTable
//             headers={headers}
//             data={reportDashboardData}
//             searchPlaceholder="Filter Student Groups..."
//             dataClient={dataClient}
//             setPagePath={setPagePath}
//             selectedRows={selectedRows}
//             setSelectedRows={setSelectedRows}
//             bulk={false}
//           />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default StudentDashboard;

// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import { Link } from "react-router-dom";
// import "jspdf-autotable";
// import { FULL_API_BASE_URL } from "../../../Config/Config";
// import Latex from "react-latex";
// import "katex/dist/katex.min.css";
// import he from "he";
// import StudentGroupDashboaardTable from "./StudentRegistrationTable";
// import EndPoints from "../../../Api/EndPoints";

// const StudentDashboard = ({
//   setMessageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
//   dataClient,
//   setPagePath,
//   setNoTimeSet,
// }) => {
//   const [reportDashboardData, setReportDashboardData] = useState([]);
//   const navigate = useNavigate();
//   const accessToken = localStorage.getItem("other");
//   const [headers, setHeaders] = useState([]);
//   const [selectedRows, setSelectedRows] = useState([]);
//   const [isLoading, setIsLoading] = useState(false); // ✅ Add loading state

//   useEffect(() => {
//     if (dataClient) {
//       fetchDashboardData();
//     }
//   }, [dataClient]);

//   const userId = dataClient?.client_schema_name?.[6]?.[0]?.user_id;
//   const userName = dataClient?.client_schema_name?.[6]?.[0]?.user_name || null;
//   const clintBranchId = dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id;

//   const fetchDashboardData = async () => {
//     // ✅ Prevent auto-close while loading
//     setNoTimeSet(true);

//     setIsLoading(true);
//     setIsMessageBoxVisible(true);
//     setMessageBox(
//       <div className="Container-messageBOX">
//         <div className="messagebox-insider1">
//           <div className="loader-tc"></div>
//           <span style={{ marginLeft: "10px", marginTop: "3px" }}>
//             Loading data, please wait...
//           </span>
//         </div>
//       </div>
//     );
//     setActiveImg(false);

//     // ⏱️ Show "taking more time" message if API takes longer than 10 seconds
//     const slowLoadingTimer = setTimeout(() => {
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span style={{ marginLeft: "10px", marginTop: "3px" }}>
//               This is taking longer than usual, please wait a moment...
//             </span>
//           </div>
//         </div>
//       );
//     }, 5000);

//     try {
//       const response = await fetch(
//         `${EndPoints.STUDENT_REG_DASHBOARD}?client_branch_id=${clintBranchId}`,
//         {
//           method: "GET",
//           headers: {
//             Authorization: `Bearer ${accessToken}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       if (!response.ok) {
//         throw new Error(
//           "Failed to fetch dashboard data. Please check the API or authentication details."
//         );
//       }

//       const result = await response.json();

//       let tableData, rawHeaders, rows;

//       if (result?.headers && result?.rows) {
//         rawHeaders = result.headers;
//         rows = result.rows;
//       } else if (result?.data) {
//         tableData = result.data;
//         rawHeaders = tableData[0] || [];
//         rows = tableData.slice(1) || [];
//       } else {
//         rawHeaders = [];
//         rows = [];
//       }

//       const formattedHeaders = rawHeaders.map((header) =>
//         String(header).replace(/^[a-zA-Z]\*/, "")
//       );

//       const transformedRows = rows.map((row) =>
//         row.map((cell) => {
//           if (cell === "" || cell === null || cell === undefined) {
//             return "---";
//           }
//           return cell;
//         })
//       );

//       setHeaders(formattedHeaders);
//       setReportDashboardData(transformedRows);

//       // ✅ Clear timer and hide loading on success
//       clearTimeout(slowLoadingTimer);
//       setIsLoading(false);
//       setNoTimeSet(false);
//       setIsMessageBoxVisible(false);

//     } catch (error) {
//       // ✅ Clear timer and show error message
//       clearTimeout(slowLoadingTimer);
//       setIsLoading(false);
//       setNoTimeSet(false);
//       setIsMessageBoxVisible(true);

//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <span style={{ marginLeft: "10px", marginTop: "3px" }}>
//               Error: {error.message}
//             </span>
//           </div>
//         </div>
//       );

//       console.error("Error fetching dashboard data:", error);
//     }
//   };

//   const handleCancel = () => {
//     window.location.reload();
//   };

//   return (
//     <div
//       style={{
//         height: "auto",
//         width: "100%",
//         paddingLeft: "37px",
//         marginBottom: "40px",
//       }}
//     >
//       <div className="">
//         <div
//           style={{
//             backgroundColor: "white",
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             zIndex: 1001,
//             top: 0,
//           }}
//         >
//           <p style={{ color: "#2F2E40", fontSize: "30px" }}>
//             Student Registration Dashboard
//           </p>
//           <div style={{ display: "flex" }}>
//             <button
//               style={{
//                 padding: "12px",
//                 marginRight: "18px",
//                 boxShadow: "0px 4px 4px 0px #00000040",
//                 marginTop: "0",
//                 opacity: isLoading ? 0.6 : 1, // ✅ Disable while loading
//                 cursor: isLoading ? "not-allowed" : "pointer",
//               }}
//               className="create-test-section-btn"
//               onClick={() => {
//                 if (!isLoading) { // ✅ Prevent navigation while loading
//                   navigate(`/student_registration`);
//                 }
//               }}
//               disabled={isLoading} // ✅ Disable button
//             >
//               NEW
//               <span style={{fontSize: "14px", fontWeight: "bold"}}>+</span>
//             </button>
//           </div>
//         </div>
//         <p style={{ marginTop: "10px", color: "#2F2E40" }}>
//           Student requests are listed here click on a student name to check status, edit or cancel the request or create a new request using New button.
//         </p>
//         <div>
//           <StudentGroupDashboaardTable
//             headers={headers}
//             data={reportDashboardData}
//             searchPlaceholder="Filter Student Groups..."
//             dataClient={dataClient}
//             setPagePath={setPagePath}
//             selectedRows={selectedRows}
//             setSelectedRows={setSelectedRows}
//             bulk={false}
//           />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default StudentDashboard;

// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import { Link } from "react-router-dom";
// import "jspdf-autotable";
// import { FULL_API_BASE_URL } from "../../../Config/Config";
// import Latex from "react-latex";
// import "katex/dist/katex.min.css";
// import he from "he";
// import StudentGroupDashboaardTable from "./StudentRegistrationTable";
// import EndPoints from "../../../Api/EndPoints";

// const StudentDashboard = ({
//   setMessageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
//   dataClient,
//   setPagePath,
// }) => {
//   const [reportDashboardData, setReportDashboardData] = useState([]);
//   const navigate = useNavigate();
//   const accessToken = localStorage.getItem("other");
//   const [headers, setHeaders] = useState([]);
//   const [selectedRows, setSelectedRows] = useState([]);

//   useEffect(() => {
//     if (dataClient) {
//       fetchDashboardData();
//     }
//   }, [dataClient]);

//   const userId = dataClient?.client_schema_name?.[6]?.[0]?.user_id;
//   const userName = dataClient?.client_schema_name?.[6]?.[0]?.user_name || null;
//   const clintBranchId = dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id;

//   const fetchDashboardData = async () => {
//     try {
//       const response = await fetch(
//         `${EndPoints.STUDENT_REG_DASHBOARD}?client_branch_id=${clintBranchId}`,
//         {
//           method: "GET",
//           headers: {
//             Authorization: `Bearer ${accessToken}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       if (!response.ok) {
//         throw new Error(
//           "Failed to fetch dashboard data. Please check the API or authentication details."
//         );
//       }

//       const result = await response.json();

//       let tableData, rawHeaders, rows;

//       if (result?.headers && result?.rows) {
//         rawHeaders = result.headers;
//         rows = result.rows;
//       } else if (result?.data) {
//         tableData = result.data;
//         rawHeaders = tableData[0] || [];
//         rows = tableData.slice(1) || [];
//       } else {
//         rawHeaders = [];
//         rows = [];
//       }

//       const formattedHeaders = rawHeaders.map((header) =>
//         String(header).replace(/^[a-zA-Z]\*/, "")
//       );

//       const transformedRows = rows.map((row) =>
//         row.map((cell) => {
//           if (cell === "" || cell === null || cell === undefined) {
//             return "---";
//           }
//           return cell;
//         })
//       );

//       setHeaders(formattedHeaders);
//       setReportDashboardData(transformedRows);
//     } catch (error) {
//       console.error("Error fetching dashboard data:", error);
//     }
//   };

//   const handleCancel = () => {
//     window.location.reload();
//   };

//   return (
//     <div
//       style={{
//         height: "auto",
//         width: "100%",
//         paddingLeft: "37px",
//         marginBottom: "40px",
//       }}
//     >
//       <div className="">
//         <div
//           style={{
//             backgroundColor: "white",
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             zIndex: 1001,
//             top: 0,
//           }}
//         >
//           <p style={{ color: "#2F2E40", fontSize: "30px" }}>
//             Student Registration Dashboard
//           </p>
//           <div style={{ display: "flex" }}>
//             <button
//               style={{
//                 padding: "12px",
//                 marginRight: "18px",
//                 boxShadow: "0px 4px 4px 0px #00000040",
//                 marginTop: "0",
//               }}
//               className="create-test-section-btn"
//               onClick={() => {
//                 navigate(`/student_registration`);
//               }}
//             >
//               NEW
//               <span style={{fontSize: "14px", fontWeight: "bold"}}>+</span>
//             </button>
//           </div>
//         </div>
//         <p style={{ marginTop: "10px", color: "#2F2E40" }}>
//           Student requests are listed here click on a student name to check status, edit or cancel the request or create a new request using New button.
//         </p>
//         <div>
//           <StudentGroupDashboaardTable
//             headers={headers}
//             data={reportDashboardData}
//             searchPlaceholder="Filter Student Groups..."
//             dataClient={dataClient}
//             setPagePath={setPagePath}
//             selectedRows={selectedRows}
//             setSelectedRows={setSelectedRows}
//             bulk={false}
//           />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default StudentDashboard;

// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import { Link } from "react-router-dom";
// import "jspdf-autotable";
// import { FULL_API_BASE_URL } from "../../../Config/Config";
// import Latex from "react-latex";
// import "katex/dist/katex.min.css";
// import he from "he";
// import StudentGroupDashboaardTable from "./StudentRegistrationTable";
// import EndPoints from "../../../Api/EndPoints";

// const StudentDashboard = ({
//   setMessageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
//   dataClient,
//   setPagePath,
//   setNoTimeSet,
// }) => {
//   const [reportDashboardData, setReportDashboardData] = useState([]);
//   const navigate = useNavigate();
//   const accessToken = localStorage.getItem("other");
//   const [headers, setHeaders] = useState([]);
//   const [selectedRows, setSelectedRows] = useState([]);
//   const [isLoading, setIsLoading] = useState(false); // ✅ Add loading state
//   // ── NEW: store raw headers to correctly resolve column indices for navigation ──
//   const [rawHeaders, setRawHeaders] = useState([]);

//   useEffect(() => {
//     if (dataClient) {
//       fetchDashboardData();
//     }
//   }, [dataClient]);

//   const userId = dataClient?.client_schema_name?.[6]?.[0]?.user_id;
//   const userName = dataClient?.client_schema_name?.[6]?.[0]?.user_name || null;
//   const clintBranchId = dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id;

//   const fetchDashboardData = async () => {
//     // ✅ Prevent auto-close while loading
//     setNoTimeSet(true);

//     setIsLoading(true);
//     setIsMessageBoxVisible(true);
//     setMessageBox(
//       <div className="Container-messageBOX">
//         <div className="messagebox-insider1">
//           <div className="loader-tc"></div>
//           <span style={{ marginLeft: "10px", marginTop: "3px" }}>
//             Loading data, please wait...
//           </span>
//         </div>
//       </div>
//     );
//     setActiveImg(false);

//     // ⏱️ Show "taking more time" message if API takes longer than 10 seconds
//     const slowLoadingTimer = setTimeout(() => {
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span style={{ marginLeft: "10px", marginTop: "3px" }}>
//               This is taking longer than usual, please wait a moment...
//             </span>
//           </div>
//         </div>
//       );
//     }, 5000);

//     try {
//       const response = await fetch(
//         `${EndPoints.STUDENT_REG_DASHBOARD}?client_branch_id=${clintBranchId}`,
//         {
//           method: "GET",
//           headers: {
//             Authorization: `Bearer ${accessToken}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       if (!response.ok) {
//         throw new Error(
//           "Failed to fetch dashboard data. Please check the API or authentication details."
//         );
//       }

//       const result = await response.json();

//       let tableData, rawHdrs, rows;

//       if (result?.headers && result?.rows) {
//         rawHdrs = result.headers;
//         rows = result.rows;
//       } else if (result?.data) {
//         tableData = result.data;
//         rawHdrs = tableData[0] || [];
//         rows = tableData.slice(1) || [];
//       } else {
//         rawHdrs = [];
//         rows = [];
//       }

//       const formattedHeaders = rawHdrs.map((header) =>
//         String(header).replace(/^[a-zA-Z]\*/, "")
//       );

//       const transformedRows = rows.map((row) =>
//         row.map((cell) => {
//           if (cell === "" || cell === null || cell === undefined) {
//             return "---";
//           }
//           return cell;
//         })
//       );

//       // ── NEW: keep rawHdrs so handleManageAccess can resolve correct indices ──
//       setRawHeaders(rawHdrs);
//       setHeaders(formattedHeaders);
//       setReportDashboardData(transformedRows);

//       // ✅ Clear timer and hide loading on success
//       clearTimeout(slowLoadingTimer);
//       setIsLoading(false);
//       setNoTimeSet(false);
//       setIsMessageBoxVisible(false);

//     } catch (error) {
//       // ✅ Clear timer and show error message
//       clearTimeout(slowLoadingTimer);
//       setIsLoading(false);
//       setNoTimeSet(false);
//       setIsMessageBoxVisible(true);

//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <span style={{ marginLeft: "10px", marginTop: "3px" }}>
//               Error: {error.message}
//             </span>
//           </div>
//         </div>
//       );

//       console.error("Error fetching dashboard data:", error);
//     }
//   };

//   const handleCancel = () => {
//     window.location.reload();
//   };

//   // ── NEW: MANAGE ACCESS handler ─────────────────────────────────────────────
//   // Collect data for checked rows and navigate to /generate_otlc
//   const handleManageAccess = () => {
//     if (selectedRows.length === 0) return;

//     // Strip prefixes from raw headers to resolve column indices
//     // API column order (0-based):
//     //  0:Photo  1:Roll Number  2:Name  3:Course  4:Batch  5:Session
//     //  6:Class Type  7:Class  8:Registration Date  9:Status
//     //  10:Student Mobile Number  ...  17:Gender ID  18:Student ID
//     //  19:Student App Access  20:Parent App Access
//     const fmtHeaders = rawHeaders.map(h => String(h).replace(/^[a-zA-Z]\*/, ""));
//     const idx = (name) => {
//       const i = fmtHeaders.indexOf(name);
//       return i >= 0 ? i : null;
//     };

//     const selectedStudents = reportDashboardData
//       .filter((row) => {
//         const sidIdx = idx("Student ID") ?? 18;
//         return selectedRows.includes(row[sidIdx]);
//       })
//       .map((row) => ({
//         studentName:      row[idx("Name")                    ?? 2]  || "",
//         rollNo:           row[idx("Roll Number")             ?? 1]  || "",
//         course:           row[idx("Course")                  ?? 3]  || "",
//         batch:            row[idx("Batch")                   ?? 4]  || "",
//         classType:        row[idx("Class Type")              ?? 6]  || "",
//         phoneNumber:      row[idx("Student Mobile Number")   ?? 10] || "",
//         status:           row[idx("Status")                  ?? 9]  || "",
//         studentAppAccess: row[idx("Student App Access")      ?? 19] || "No",
//         parentAppAccess:  row[idx("Parent App Access")       ?? 20] || "No",
//         studentId:        row[idx("Student ID")              ?? 18] || "",
//       }));

//     navigate("/generate_otlc", { state: { students: selectedStudents } });
//   };

//   const hasSelection = selectedRows.length > 0;

//   return (
//     <div
//       style={{
//         height: "auto",
//         width: "100%",
//         paddingLeft: "37px",
//         marginBottom: "40px",
//       }}
//     >
//       <div className="">
//         <div
//           style={{
//             backgroundColor: "white",
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             zIndex: 1001,
//             top: 0,
//           }}
//         >
//           <p style={{ color: "#2F2E40", fontSize: "30px" }}>
//             Student Registration Dashboard
//           </p>
//           <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
//             {/* ── NEW: MANAGE ACCESS – enabled only when a row is checked ── */}
//             <button
//               style={{
//                 padding: "12px 24px",
//                 marginRight: "0px",
//                 boxShadow: "0px 4px 4px 0px #00000040",
//                 marginTop: "0",
//                 whiteSpace: "nowrap",
//                 opacity: hasSelection ? 1 : 0.4,
//                 cursor: hasSelection ? "pointer" : "not-allowed",
//                 width: "150px"
//               }}
//               className="create-test-section-btn"
//               onClick={handleManageAccess}
//               disabled={!hasSelection}
//               title={
//                 hasSelection
//                   ? "Manage access for selected student(s)"
//                   : "Select at least one student to enable"
//               }
//             >
//               MANAGE ACCESS
//             </button>

//             {/* ── Original NEW button (unchanged) ── */}
//             <button
//               style={{
//                 padding: "12px",
//                 marginRight: "18px",
//                 boxShadow: "0px 4px 4px 0px #00000040",
//                 marginTop: "0",
//                 opacity: isLoading ? 0.6 : 1, // ✅ Disable while loading
//                 cursor: isLoading ? "not-allowed" : "pointer",
//               }}
//               className="create-test-section-btn"
//               onClick={() => {
//                 if (!isLoading) { // ✅ Prevent navigation while loading
//                   navigate(`/student_registration`);
//                 }
//               }}
//               disabled={isLoading} // ✅ Disable button
//             >
//               NEW
//               <span style={{fontSize: "14px", fontWeight: "bold"}}>+</span>
//             </button>
//           </div>
//         </div>
//         <p style={{ marginTop: "10px", color: "#2F2E40" }}>
//           Student requests are listed here click on a student name to check status, edit or cancel the request or create a new request using New button.
//         </p>
//         <div>
//           <StudentGroupDashboaardTable
//             headers={headers}
//             data={reportDashboardData}
//             searchPlaceholder="Filter Student Groups..."
//             dataClient={dataClient}
//             setPagePath={setPagePath}
//             selectedRows={selectedRows}
//             setSelectedRows={setSelectedRows}
//             bulk={true}
//           />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default StudentDashboard;

import React, { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import "jspdf-autotable";
import StudentRegistrationTable from "./StudentRegistrationTable";
import EndPoints from "../../../Api/EndPoints";

const StudentDashboard = ({
  setMessageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  dataClient,
  setPagePath,
  setNoTimeSet,
}) => {
  const navigate = useNavigate();
  const accessToken = localStorage.getItem("other");
  const clintBranchId =
    dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id;

  // ── Table data ───────────────────────────────────────────────────────────────
  const [headers, setHeaders] = useState([]);
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // ── Pagination ────────────────────────────────────────────────────────────────
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState(0);
  const [totalPages, setTotalPages] = useState(1);

  // ── Search ────────────────────────────────────────────────────────────────────
  const [search, setSearch] = useState("");
  const debounceRef = useRef(null);

  // ── Filters ───────────────────────────────────────────────────────────────────
  const [filterOptions, setFilterOptions] = useState(null);
  const [pendingFilters, setPendingFilters] = useState({});
  const [appliedFilters, setAppliedFilters] = useState({});
  const [isFilterVisible, setIsFilterVisible] = useState(false);

  // ── Selection ─────────────────────────────────────────────────────────────────
  const [selectedRows, setSelectedRows] = useState([]);

  // ── Fetch filter options once on mount ────────────────────────────────────────
  useEffect(() => {
    if (!clintBranchId) return;
    fetch(
      `${EndPoints.STUDENT_DASHBOARD_FILTER_OPTIONS}?client_branch_id=${clintBranchId}`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          accept: "application/json",
        },
      }
    )
      .then((r) => r.json())
      .then((data) => setFilterOptions(data))
      .catch((e) => console.error("Filter options fetch failed:", e));
  }, [clintBranchId]);

  // ── Core data fetch ───────────────────────────────────────────────────────────
  const fetchData = useCallback(
    async ({ pageVal, pageSizeVal, searchVal, filtersVal }) => {
      if (!clintBranchId) return;

      setIsLoading(true);
      if (setNoTimeSet) setNoTimeSet(true);

      const slowTimer = setTimeout(() => {
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span style={{ marginLeft: "10px", marginTop: "3px" }}>
                This is taking longer than usual, please wait...
              </span>
            </div>
          </div>
        );
        setIsMessageBoxVisible(true);
      }, 5000);

      const params = new URLSearchParams({
        client_branch_id: clintBranchId,
        page: pageVal,
        page_size: pageSizeVal,
      });

      if (searchVal?.trim()) params.append("search", searchVal.trim());

      const filterParamMap = {
        course: "course",
        batch: "batch",
        session: "session",
        class_type: "class_type",
        class_name: "class_name",
        status: "status",
        student_app_access: "student_app_access",
        parent_app_access: "parent_app_access",
        roll_number: "roll_number",
        name: "name",
        student_mobile: "student_mobile",
        fathers_name: "fathers_name",
        fathers_mobile: "fathers_mobile",
        mothers_name: "mothers_name",
        mothers_mobile: "mothers_mobile",
        emergency_contact: "emergency_contact",
        emergency_number: "emergency_number",
        reg_date_from: "reg_date_from",
        reg_date_to: "reg_date_to",
      };

      Object.entries(filtersVal || {}).forEach(([key, val]) => {
        if (val && val.trim() && filterParamMap[key]) {
          params.append(filterParamMap[key], val.trim());
        }
      });

      try {
        const res = await fetch(
          `${EndPoints.STUDENT_DASHBOARD_V2}?${params.toString()}`,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
              accept: "application/json",
            },
          }
        );
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const data = await res.json();

        const rawHeaders = data.headers || [];
        setHeaders(rawHeaders.map((h) => String(h).replace(/^[a-zA-Z]\*/, "")));

        const transformedRows = (data.rows || []).map((row) =>
          row.map((cell) =>
            cell === "" || cell === null || cell === undefined ? "---" : cell
          )
        );
        setRows(transformedRows);
        setTotal(data.total || 0);
        setTotalPages(data.total_pages || 1);
      } catch (err) {
        console.error("Dashboard fetch error:", err);
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <span style={{ marginLeft: "10px", marginTop: "3px" }}>
                Error: {err.message}
              </span>
            </div>
          </div>
        );
        setIsMessageBoxVisible(true);
      } finally {
        clearTimeout(slowTimer);
        setIsLoading(false);
        if (setNoTimeSet) setNoTimeSet(false);
        setIsMessageBoxVisible(false);
      }
    },
    [clintBranchId, accessToken]
  );

  // ── Load on mount and when pagination/filters change ─────────────────────────
  useEffect(() => {
    if (!clintBranchId) return;
    fetchData({
      pageVal: page,
      pageSizeVal: pageSize,
      searchVal: search,
      filtersVal: appliedFilters,
    });
  }, [page, pageSize, appliedFilters, clintBranchId]);

  // ── Search with 300ms debounce, resets to page 1 ─────────────────────────────
  const handleSearchChange = (e) => {
    const val = e.target.value;
    setSearch(val);
    clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      setPage(1);
      fetchData({
        pageVal: 1,
        pageSizeVal: pageSize,
        searchVal: val,
        filtersVal: appliedFilters,
      });
    }, 300);
  };

  // ── Pagination handlers ───────────────────────────────────────────────────────
  const handlePageChange = (newPage) => {
    if (newPage < 1 || newPage > totalPages) return;
    setPage(newPage);
  };

  const handlePageSizeChange = (newSize) => {
    setPageSize(newSize);
    setPage(1);
  };

  // ── Filter handlers ───────────────────────────────────────────────────────────
  const handleApplyFilters = () => {
    setAppliedFilters({ ...pendingFilters });
    setPage(1);
    setIsFilterVisible(false);
  };

  const handleResetFilters = () => {
    setPendingFilters({});
    setAppliedFilters({});
    setPage(1);
    setIsFilterVisible(false);
  };

  // ── Manage Access ─────────────────────────────────────────────────────────────
  const handleManageAccess = () => {
    if (selectedRows.length === 0) return;
    const idx = (name) => {
      const i = headers.indexOf(name);
      return i >= 0 ? i : null;
    };
    const selectedStudents = rows
      .filter((row) => selectedRows.includes(row[idx("Student ID") ?? 18]))
      .map((row) => ({
        studentName: row[idx("Name") ?? 2] || "",
        rollNo: row[idx("Roll Number") ?? 1] || "",
        course: row[idx("Course") ?? 3] || "",
        batch: row[idx("Batch") ?? 4] || "",
        classType: row[idx("Class Type") ?? 6] || "",
        phoneNumber: row[idx("Student Mobile Number") ?? 10] || "",
        status: row[idx("Status") ?? 9] || "",
        studentAppAccess: row[idx("Student App Access") ?? 19] || "No",
        parentAppAccess: row[idx("Parent App Access") ?? 20] || "No",
        studentId: row[idx("Student ID") ?? 18] || "",
      }));
    navigate("/generate_otlc", { state: { students: selectedStudents } });
  };

  const hasSelection = selectedRows.length > 0;
  const hasAppliedFilters = Object.values(appliedFilters).some(
    (v) => v && v.trim()
  );

  return (
    <div
      style={{
        height: "auto",
        width: "100%",
        paddingLeft: "37px",
        marginBottom: "40px",
      }}
    >
      <div>
        <div
          style={{
            backgroundColor: "white",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            zIndex: 1001,
            top: 0,
          }}
        >
          <p style={{ color: "#2F2E40", fontSize: "30px" }}>
            Student Registration Dashboard
          </p>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <button
              style={{
                padding: "12px 24px",
                marginRight: "0px",
                boxShadow: "0px 4px 4px 0px #00000040",
                marginTop: "0",
                whiteSpace: "nowrap",
                width: "150px",
                opacity: hasSelection ? 1 : 0.4,
                cursor: hasSelection ? "pointer" : "not-allowed",
              }}
              className="create-test-section-btn"
              onClick={handleManageAccess}
              disabled={!hasSelection}
              title={
                hasSelection
                  ? "Manage access for selected student(s)"
                  : "Select at least one student to enable"
              }
            >
              MANAGE ACCESS
            </button>
            <button
              style={{
                padding: "12px",
                marginRight: "18px",
                boxShadow: "0px 4px 4px 0px #00000040",
                marginTop: "0",
                opacity: isLoading ? 0.6 : 1,
                cursor: isLoading ? "not-allowed" : "pointer",
              }}
              className="create-test-section-btn"
              onClick={() => {
                if (!isLoading) navigate("/student_registration");
              }}
              disabled={isLoading}
            >
              NEW{" "}
              <span style={{ fontSize: "14px", fontWeight: "bold" }}>+</span>
            </button>
          </div>
        </div>

        <p style={{ marginTop: "10px", color: "#2F2E40" }}>
          Student requests are listed here click on a student name to check
          status, edit or cancel the request or create a new request using New
          button.
        </p>

        <StudentRegistrationTable
          headers={headers}
          rows={rows}
          total={total}
          totalPages={totalPages}
          page={page}
          pageSize={pageSize}
          isLoading={isLoading}
          search={search}
          onSearchChange={handleSearchChange}
          onPageChange={handlePageChange}
          onPageSizeChange={handlePageSizeChange}
          filterOptions={filterOptions}
          pendingFilters={pendingFilters}
          setPendingFilters={setPendingFilters}
          appliedFilters={appliedFilters}
          hasAppliedFilters={hasAppliedFilters}
          isFilterVisible={isFilterVisible}
          setIsFilterVisible={setIsFilterVisible}
          onApplyFilters={handleApplyFilters}
          onResetFilters={handleResetFilters}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          bulk={true}
        />
      </div>
    </div>
  );
};

export default StudentDashboard;
